'use strict'

import React from 'react'

import Link from '../../helper/link'
import { DiffTable } from './DiffTable'
import { partitionDiffData } from './diffHelpers'
import { TraceDiffItem } from '../../domain/Trace'
import { TraceDiffTranslation, TraceSummarySingleView } from '../../domain/TraceSummary'

type Props = {
    base: TraceSummarySingleView
    target: TraceSummarySingleView
    diff?: TraceDiffItem[]
    count?: number
    traceDiffTranslation: TraceDiffTranslation
}

type State = {
    sort: 'wt' | 'excl_wt'
}

class PublicDiff extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = { sort: 'excl_wt' }
    }

    setSortBy(sort: State['sort']) {
        this.setState({ sort: sort })
    }

    render() {
        const { diff = [], count = 10, traceDiffTranslation } = this.props
        const { faster, slower } = partitionDiffData(diff, count, this.state.sort)

        return (
            <div className="box">
                <div className="box-body">
                    <div className="row">
                        <div className="col-lg-6 col-md-12">
                            <h3>
                                Calls faster{' '}
                                <Link
                                    route="XhprofCoreBundle.Public.sharedTrace.quick"
                                    params={{ shareId: this.props.base.sharedTraceInfo?.sharedTraceId }}
                                >
                                    {traceDiffTranslation.from}
                                </Link>
                            </h3>
                            <DiffTable items={faster} sort={this.state.sort} onSortChange={sortKey => this.setSortBy(sortKey)} />
                        </div>
                        <div className="col-lg-6 col-md-12">
                            <h3>
                                Calls faster{' '}
                                <Link
                                    route="XhprofCoreBundle.Public.sharedTrace.quick"
                                    params={{ shareId: this.props.target.sharedTraceInfo?.sharedTraceId }}
                                >
                                    {traceDiffTranslation.to}
                                </Link>
                            </h3>
                            <DiffTable items={slower} sort={this.state.sort} onSortChange={sortKey => this.setSortBy(sortKey)} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default PublicDiff
